"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.richTextTouchEndDebounceTime = exports.orderListTypeToText = exports.VIEW_ARTICLE_TEXT = exports.USERTYPE = exports.UNSUPPORTED_MESSAGE = exports.UNPAID_TEXT = exports.TYPE_ALL = exports.TO_SHIP_TEXT = exports.TO_RECEIVE_TEXT = exports.TO_PAY_TEXT = exports.TOTAL_TEXT = exports.TOTAL_PAYMENT_TEXT = exports.STILL_NOT_SEE_TRANSACTION = exports.SHIPPING_TEXT = exports.SELLER_TITLES = exports.SELLER_RETURN_REFUND_TEXT = exports.SELLER_QUERY_TYPE = exports.SELLER_ORDER_LIST_TITLE_TEXT = exports.SELLER_CANCELLED_TEXT = exports.SELECT_ORDER_TEXT = exports.RETURN_REFUND_TYPE = exports.RETURN_REFUND_TEXT = exports.REFUND_AMOUNT_TEXT = exports.PAGE_HEAD_TITLE = exports.ORDER_STH_WENT_WRONG_TEXT = exports.ORDER_ID_TRANSIFY_KEY = exports.NO_ORDERS_YET_TEXT = exports.MODAL_CLOSE_TEXT = exports.LABEL_WITHDRAWAL = exports.LABEL_TOPUP = exports.LABEL_ORDER_TIME = exports.ITEM_TEXT = exports.ITEMS_TEXT = exports.GROUP_ORDER_TEXT = exports.DELIVERED_BY_TEXT = exports.DEFAULT_ORDER_TYPE_DECS_LIST = exports.COPY_TEXT = exports.CONTACT_COURIER_CARD = exports.COMPLETED_TEXT = exports.CANCELLED_TEXT = exports.ButtonStyle = exports.BUYER_QUERY_TYPE = exports.BUYER_ORDER_LIST_TITLE_TEXT = exports.BTN_CHOOSE_ISSUE = exports.AUTH_TYPE = exports.AUTH_BIZ_NAME = exports.ALL_TEXT = void 0;
// 固定transify文案
// 状态 tab文案
var TO_PAY_TEXT = 'to_pay_text';
exports.TO_PAY_TEXT = TO_PAY_TEXT;
var TO_SHIP_TEXT = 'to_ship_text';
exports.TO_SHIP_TEXT = TO_SHIP_TEXT;
var TO_RECEIVE_TEXT = 'to_receive_text';
exports.TO_RECEIVE_TEXT = TO_RECEIVE_TEXT;
var COMPLETED_TEXT = 'completed_text';
exports.COMPLETED_TEXT = COMPLETED_TEXT;
var CANCELLED_TEXT = 'cancelled_text';
exports.CANCELLED_TEXT = CANCELLED_TEXT;
var UNPAID_TEXT = 'unpaid_text';
exports.UNPAID_TEXT = UNPAID_TEXT;
var SHIPPING_TEXT = 'shipping_text';
exports.SHIPPING_TEXT = SHIPPING_TEXT;
var RETURN_REFUND_TEXT = 'return_refund_text';
exports.RETURN_REFUND_TEXT = RETURN_REFUND_TEXT;
var ALL_TEXT = 'all_text';
exports.ALL_TEXT = ALL_TEXT;
var SELLER_RETURN_REFUND_TEXT = 'seller_return_refund_text';
exports.SELLER_RETURN_REFUND_TEXT = SELLER_RETURN_REFUND_TEXT;
var SELLER_CANCELLED_TEXT = 'seller_cancelled_text'; // 买家订单列表标题

exports.SELLER_CANCELLED_TEXT = SELLER_CANCELLED_TEXT;
var BUYER_ORDER_LIST_TITLE_TEXT = 'buyer_order_list_title_text';
exports.BUYER_ORDER_LIST_TITLE_TEXT = BUYER_ORDER_LIST_TITLE_TEXT;
var GROUP_ORDER_TEXT = 'group_order_text'; // 卖家订单列表

exports.GROUP_ORDER_TEXT = GROUP_ORDER_TEXT;
var SELLER_ORDER_LIST_TITLE_TEXT = 'seller_order_list_title_text';
exports.SELLER_ORDER_LIST_TITLE_TEXT = SELLER_ORDER_LIST_TITLE_TEXT;
var SELECT_ORDER_TEXT = 'select_order_text'; // Items

exports.SELECT_ORDER_TEXT = SELECT_ORDER_TEXT;
var ITEMS_TEXT = 'items_text';
exports.ITEMS_TEXT = ITEMS_TEXT;
var ITEM_TEXT = 'item_text';
exports.ITEM_TEXT = ITEM_TEXT;
var DELIVERED_BY_TEXT = 'delivered_by_text';
exports.DELIVERED_BY_TEXT = DELIVERED_BY_TEXT;
var COPY_TEXT = 'copy_text';
exports.COPY_TEXT = COPY_TEXT;
var LABEL_ORDER_TIME = 'label_order_time'; // toatl

exports.LABEL_ORDER_TIME = LABEL_ORDER_TIME;
var TOTAL_TEXT = 'total_text'; // Toal Payment

exports.TOTAL_TEXT = TOTAL_TEXT;
var TOTAL_PAYMENT_TEXT = 'total_payment_text';
exports.TOTAL_PAYMENT_TEXT = TOTAL_PAYMENT_TEXT;
var REFUND_AMOUNT_TEXT = 'refund_amount_text'; // 单篇文章的btn文案

exports.REFUND_AMOUNT_TEXT = REFUND_AMOUNT_TEXT;
var VIEW_ARTICLE_TEXT = 'view_article_text'; // 不支持消息类型的文案

exports.VIEW_ARTICLE_TEXT = VIEW_ARTICLE_TEXT;
var UNSUPPORTED_MESSAGE = 'unsupported_message';
exports.UNSUPPORTED_MESSAGE = UNSUPPORTED_MESSAGE;
var MODAL_CLOSE_TEXT = 'modal_close_text'; // title

exports.MODAL_CLOSE_TEXT = MODAL_CLOSE_TEXT;
var PAGE_HEAD_TITLE = 'page_head_title';
exports.PAGE_HEAD_TITLE = PAGE_HEAD_TITLE;
var BTN_CHOOSE_ISSUE = 'btn_choose_issue'; // 订单获取失败

exports.BTN_CHOOSE_ISSUE = BTN_CHOOSE_ISSUE;
var ORDER_STH_WENT_WRONG_TEXT = 'order_sth_went_wrong_text'; // 订单列表为空

exports.ORDER_STH_WENT_WRONG_TEXT = ORDER_STH_WENT_WRONG_TEXT;
var NO_ORDERS_YET_TEXT = 'no_orders_yet_text';
exports.NO_ORDERS_YET_TEXT = NO_ORDERS_YET_TEXT;
var LABEL_WITHDRAWAL = 'label_withdrawal';
exports.LABEL_WITHDRAWAL = LABEL_WITHDRAWAL;
var LABEL_TOPUP = 'label_topup'; // 常量定义

exports.LABEL_TOPUP = LABEL_TOPUP;
var BUYER_QUERY_TYPE = {
  toPay: 1,
  toShip: 2,
  toReceive: 3,
  completed: 4,
  cancelled: 5
};
exports.BUYER_QUERY_TYPE = BUYER_QUERY_TYPE;
var SELLER_QUERY_TYPE = {
  unPaid: 6,
  toShip: 7,
  shipped: 8,
  completed: 9,
  cancelled: 10
};
exports.SELLER_QUERY_TYPE = SELLER_QUERY_TYPE;
var orderListTypeToText = {
  0: ALL_TEXT,
  1: TO_PAY_TEXT,
  2: TO_SHIP_TEXT,
  3: TO_RECEIVE_TEXT,
  4: COMPLETED_TEXT,
  5: CANCELLED_TEXT,
  6: UNPAID_TEXT,
  7: TO_SHIP_TEXT,
  8: SHIPPING_TEXT,
  9: COMPLETED_TEXT,
  10: SELLER_CANCELLED_TEXT
};
exports.orderListTypeToText = orderListTypeToText;
var USERTYPE = {
  Buyer: 1,
  Seller: 2
};
exports.USERTYPE = USERTYPE;
var TYPE_ALL = 0;
exports.TYPE_ALL = TYPE_ALL;
var RETURN_REFUND_TYPE = -1;
exports.RETURN_REFUND_TYPE = RETURN_REFUND_TYPE;
var AUTH_TYPE = 1;
exports.AUTH_TYPE = AUTH_TYPE;
var AUTH_BIZ_NAME = 'inhouse_webform';
exports.AUTH_BIZ_NAME = AUTH_BIZ_NAME;
var ORDER_ID_TRANSIFY_KEY = 'order_id';
exports.ORDER_ID_TRANSIFY_KEY = ORDER_ID_TRANSIFY_KEY;
var STILL_NOT_SEE_TRANSACTION = 'still_not_see_transaction'; // seller 弹窗tab

exports.STILL_NOT_SEE_TRANSACTION = STILL_NOT_SEE_TRANSACTION;
var SELLER_TITLES = [{
  name: ALL_TEXT,
  type: TYPE_ALL
}, {
  name: UNPAID_TEXT,
  type: SELLER_QUERY_TYPE.unPaid
}, {
  name: TO_SHIP_TEXT,
  type: SELLER_QUERY_TYPE.toShip
}, {
  name: SHIPPING_TEXT,
  type: SELLER_QUERY_TYPE.shipped
}, {
  name: COMPLETED_TEXT,
  type: SELLER_QUERY_TYPE.completed
}, {
  name: SELLER_CANCELLED_TEXT,
  type: SELLER_QUERY_TYPE.cancelled
}, {
  name: SELLER_RETURN_REFUND_TEXT,
  type: RETURN_REFUND_TYPE
}];
exports.SELLER_TITLES = SELLER_TITLES;
var CONTACT_COURIER_CARD = {
  TRACKING_NUMBER_COPIED: 'tracking_number_copied',
  YOU_CAN_CONNECT_DRIVER: 'you_can_connect_driver',
  FACEBOOK: 'facebook',
  WHATS_APP: 'whats_app',
  EMAIL: 'email',
  CALL: 'call',
  LINE: 'line',
  CONTACT_COURIER_ANY_QUESTION: 'contact_courier_any_question',
  TRACK_ORDER: 'track_order',
  DRIVER: 'driver',
  OPERATION_HOURS: 'operation_hours',
  CANCEL: 'cancel',
  CALL_DRIVER: 'call_driver',
  CONTACT_COURIER: 'contact_courier',
  CONTACT_DRIVER: 'contact_driver'
};
exports.CONTACT_COURIER_CARD = CONTACT_COURIER_CARD;
var DEFAULT_ORDER_TYPE_DECS_LIST = [TO_PAY_TEXT, TO_SHIP_TEXT, TO_RECEIVE_TEXT, COMPLETED_TEXT, CANCELLED_TEXT, UNPAID_TEXT, TO_SHIP_TEXT, SHIPPING_TEXT, COMPLETED_TEXT, SELLER_CANCELLED_TEXT];
exports.DEFAULT_ORDER_TYPE_DECS_LIST = DEFAULT_ORDER_TYPE_DECS_LIST;
var richTextTouchEndDebounceTime = 300; // 富文本 redirection button style

exports.richTextTouchEndDebounceTime = richTextTouchEndDebounceTime;
var ButtonStyle;
exports.ButtonStyle = ButtonStyle;
(function (ButtonStyle) {
  ButtonStyle[ButtonStyle["PrimaryButton"] = 1] = "PrimaryButton";
  ButtonStyle[ButtonStyle["PrimaryButtonOutlined"] = 2] = "PrimaryButtonOutlined";
  ButtonStyle[ButtonStyle["SecondaryButtonOutlined"] = 3] = "SecondaryButtonOutlined";
})(ButtonStyle || (exports.ButtonStyle = ButtonStyle = {}));